"use client";

import Link from "next/link";

export default function CategoryGrid({ item, currentPageAide }) {
  return (
    <>
      <Link
        href={`/${currentPageAide?.seo_permalink}${item.service_url}`}
        className="group"
      >
        <div className="px-3 py-3 bg-primary-50/50 group-hover:bg-primary-1000 transition duration-150 rounded-xl text-center">
          <div className="py-8">
            <div className="h-12 w-12 mx-auto text-5xl text-primary-500 group-hover:text-white wow animate__animated animate__fadeInUp overflow-hidden">
              <img
                className="border-white w-full h-full"
                src={`${item.cover_path ?? "/images/icons/bain-hygiene.svg"}`}
                alt={`${item.alt ?? "Vieillir à la maison image catégorie"}`}
              />
            </div>
          </div>
          <h4
            className="mb-5 text-lg font-semibold group-hover:text-white transition duration-150 wow animate__animated animate__fadeInUp"
            style={{ wordBreak: "break-word" }}
          >
            {item.title}
          </h4>
        </div>
      </Link>
    </>
  );
}
